<div class="d-flex w-100 rounded position-relative p-3" style="height:450px" *ngIf="FirstSlide" [ngStyle]="{ 'background': mainSectionBackgroundUrl() + ' top center / cover no-repeat' }" id="mainSection">
    <!--Custom Slide Modules-->
    <gridster class="grid-canvas" style="background:transparent !important" *ngIf="FirstSlideType == 0 && FirstSlide.WallboardModuleDetails[0]?.State" [options]="gridsterOptions" #gridCanvas>
        <gridster-item class="color-white rounded" [class.p-2]="module.WallboardModuleID != 10 || module.placeholder"
                       [ngStyle]="{ 'background-color': module.WallboardModuleID != 10 || module.placeholder ? 'rgba(51, 51, 51, 0.7)' : 'transparent' }"
                       [item]="module" *ngFor="let module of FirstSlide.WallboardModuleDetails">
            <!--Gauge-->
            <div class="d-flex flex-column justify-content-between align-items-center h-100" style="text-shadow:2px 2px 8px #000000" *ngIf="module.WallboardModuleID == 8 && !module.placeholder">
                <div class="w-100 font-size-36 text-center text-truncate" style="min-height:58px" *ngIf="module.State?.gaugeObj?.GaugeTitle">{{module.State?.gaugeObj?.GaugeTitle}}</div>
                <div class="font-size-36 invisible" *ngIf="!module.State?.gaugeObj?.GaugeTitle">Placeholder</div>
                <div class="w-100 h-100" style="background:url(../App_Themes/Standard/Images/Wallboards/gauge_wallboard_preview.png) center center / contain no-repeat"></div>
                <div class="w-100 font-size-28 text-center text-truncate" style="min-height:42px" *ngIf="module.State?.gaugeObj?.GaugeMetricDisplay">{{module.State?.gaugeObj?.GaugeMetricDisplay}}</div>
                <div class="font-size-28 invisible" *ngIf="!module.State?.gaugeObj?.GaugeMetricDisplay">Placeholder</div>
            </div>

            <!--Thermometer-->
            <div class="d-flex flex-column align-items-center h-100" style="text-shadow:2px 2px 8px #000000" *ngIf="module.WallboardModuleID == 9 && !module.placeholder">
                <div class="w-100 h-100" style="background:url(../App_Themes/Standard/Images/Wallboards/GenericThermometer.svg) center center / contain no-repeat"></div>
                <div class="w-100 font-size-36 text-center text-truncate" style="min-height:58px" *ngIf="module.State?.thermometerObj?.ThermometerTitle">{{module.State?.thermometerObj?.ThermometerTitle}}</div>
                <div class="font-size-36 invisible" *ngIf="!module.State?.thermometerObj?.ThermometerTitle">Placeholder</div>
                <div class="font-size-28" *ngIf="module.State?.thermometerObj?.ThermometerMetricDisplay">{{module.State?.thermometerObj?.ThermometerMetricDisplay}}</div>
                <div class="font-size-28 invisible" *ngIf="!module.State?.thermometerObj?.ThermometerMetricDisplay">Placeholder</div>
            </div>

            <!--Summary-->
            <div class="d-flex flex-column h-100" style="text-shadow:2px 2px 8px #000000" *ngIf="module.WallboardModuleID == 10 && !module.placeholder">
                <div class="d-flex align-items-center font-size-28 rounded pl-3 mb-2" style="height:20%; background-color:rgba(51, 51, 51, 0.7)" *ngIf="module.State?.sumObj?.SummaryTitle">
                    <span class="text-truncate">{{module.State?.sumObj?.SummaryTitle}}</span>
                </div>

                <div class="flex-grow-1 font-size-18 rounded px-3 py-2" style="background-color:rgba(51, 51, 51, 0.7)">
                    <div class="d-flex border-bottom" style="border-color:white !important">
                        <div class="w-25" cvLocalizedText langSection="Common" langKey="Name">Name</div>
                        <div class="w-25" *ngFor="let metric of module.State?.sumObj?.SumMetricDisplays">{{metric}}</div>
                    </div>

                    <div class="d-flex py-1 border-bottom" style="border-color:white !important" *ngFor="let item of [].constructor(20)">
                        <div class="w-25" cvLocalizedText langSection="Common" langKey="Name">Name</div>
                        <div class="w-25" *ngFor="let metric of module.State?.sumObj?.SumMetricDisplays">00</div>
                    </div>
                </div>
            </div>

            <!--Text-->
            <div class="text-center" style="text-shadow:2px 2px 8px #000000" [innerHTML]="module.State?.textObj?.TextValue" *ngIf="module.WallboardModuleID == 12 && !module.placeholder"></div>

            <!--Image-->
            <div class="d-flex justify-content-center align-items-center h-100" *ngIf="module.WallboardModuleID == 13 && !module.placeholder">
                <div class="w-100 h-100" [style.background]="'url(../Admin/ImageResizer.aspx?imgid=' + module.State?.imgObj?.UploadedImageID + '&w=auto&h=auto) center center / contain no-repeat'"
                     *ngIf="module.State"></div>
            </div>

            <!--Top-->
            <div class="d-flex flex-column justify-content-around align-items-center h-100" style="text-shadow:2px 2px 8px #000000" *ngIf="module.WallboardModuleID == 14 && !module.placeholder">
                <div class="w-100 font-size-28 text-center text-truncate">{{module.State?.topObj?.TopTitle}} - {{module.State?.topObj?.TopMetricDisplay}}</div>
                <div class="w-100" style="background:url(../App_Themes/Standard/Images/Wallboards/GenericTopModule.png) center center / contain no-repeat; height:60%"></div>
            </div>

            <!--Agent Counter-->
            <div class="d-flex flex-column align-items-center h-100" style="text-shadow:2px 2px 8px #000000" *ngIf="module.WallboardModuleID == 16 && !module.placeholder">
                <div class="w-100 text-center text-truncate font-size-20" style="overflow:hidden; height:30px">{{module.State?.counterObj?.CounterTitle}}</div>

                <div class="position-relative w-100" [ngStyle]="{'height': module.State?.counterObj?.ShowLabels ? '80%' : '100%'}">
                    <div class="font-size-24 position-absolute" style="top:50%; left:50%; transform:translate(-50%,-50%)">00</div>

                    <canvas [id]="'chart' + module.WallboardModuleKey"></canvas>
                </div>

                <!--Legend-->
                <div class="d-flex justify-content-center align-items-center" style="height: 18px;" *ngIf="module.State?.counterObj?.ShowLabels">
                    <div class="mr-1" style="height:12px; width:12px; background-color:#bd2026"></div>
                    <span style="width:75px" cvLocalizedText langSection="Wallboard_Management" langKey="Unavailable">Unavailable</span>

                    <div class="mx-1" style="height:12px; width:12px; background-color:#e4b321"></div>
                    <span style="width:75px" cvLocalizedText langSection="Wallboard_Management" langKey="Outbound">Outbound</span>

                    <div class="mx-1" style="height:12px; width:12px; background-color:#7c52bf"></div>
                    <span style="width:75px" cvLocalizedText langSection="Wallboard_Management" langKey="Inbound">Inbound</span>
                </div>

                <div class="d-flex justify-content-center align-items-center ml-2" style="height: 18px;" *ngIf="module.State?.counterObj?.ShowLabels">
                    <div class="mr-1" style="height:12px; width:12px; background-color:#f16622"></div>
                    <span style="width:75px">ACW</span>

                    <div class="mx-1" style="height:12px; width:12px; background-color:#3d9649"></div>
                    <span style="width:75px" cvLocalizedText langSection="Wallboard_Management" langKey="Available">Available</span>

                    <div style="width:103px"></div>
                </div>
            </div>

            <!--KPI-->
            <div class="d-flex h-100" style="text-shadow:2px 2px 8px #000000" *ngIf="module.WallboardModuleID == 18 && !module.placeholder">
                <div style="border:5px solid #a8afb9; border-radius:5px"></div>

                <div class="w-100 d-flex flex-column justify-content-between align-items-center flex-grow-1">
                    <div class="w-100 font-size-18 text-center text-truncate font-size-14" style="min-height:27px">{{module.State?.kpiObj?.KpiTitle}}</div>
                    <div class="font-size-28" style="line-height:24px">{{module.State?.kpiObj?.mCT == 4 ? "00:00:00" : "0"}}</div>
                    <div class="font-size-14" style="min-height:21px">{{module.State?.kpiObj?.KpiMetricDisplay}}</div>
                </div>
            </div>
        </gridster-item>
    </gridster>

    <!--Marketplace Preview-->
    <img class="w-100 h-100" [src]="'../App_Themes/Standard/Images/Wallboards/MarketplacePreview' + TypeState?.Marketplace_Setup?.DisplayOption + '.png'" *ngIf="FirstSlideType == 21 && TypeState?.Marketplace_Setup" />

    <!--Games Preview-->
    <div *ngIf="FirstSlideType == 19">
        <img class="w-100 h-100"
             [src]="'../App_Themes/clearview-default/images/gamification/games-wallboard-preview/' + TypeState?.Wallboard_Game_Settings?.GameType + '-' + TypeState?.Wallboard_Game_Settings?.DisplayOption + '.png'"
             *ngIf="TypeState?.Wallboard_Game_Settings?.GameType > 0" />

        <img class="w-100 h-100" src="../App_Themes/clearview-default/images/gamification/games-wallboard-preview/1-0.png" *ngIf="TypeState?.Wallboard_Game_Settings?.GameType == 0" />
    </div>

    <!--Spotlight Preview-->
    <div class="d-flex h-100 w-100 color-white overflow-hidden p-5" style="text-shadow:2px 2px 8px #000000" [ngStyle]="{ 'background': FirstSlide.HasBackdrop ? 'rgba(0,0,0,0.7)' : '' }" *ngIf="FirstSlideType == 7">
        <div style="flex:1">
            <div class="font-size-48 text-center text-truncate" style="border-bottom:2px solid #FFFFFF">{{TypeState?.Spotlight_Setup?.LoginName}}</div>
            <div class="font-size-18 mt-3" style="white-space:pre-wrap">{{getBioText(TypeState?.Spotlight_Setup?.UseProfileBio)}}</div>
        </div>

        <div class="ml-5" style="background:url(../Admin/ImageResizer.aspx?imgid=-2&w=290&h=290) top center / contain no-repeat; width:290px; height:290px"></div>
    </div>

    <!--Leaderboard Preview-->
    <div class="d-flex flex-column w-100 color-white overflow-hidden p-5" style="text-shadow:2px 2px 8px #000000" [style.background]="FirstSlide.HasBackdrop ? 'rgba(0,0,0,0.7)' : ''" *ngIf="FirstSlideType == 1">
        <div class="font-size-48 text-truncate">
            <span *ngIf="TypeState?.Leaderboard_Setup?.LeaderboardTitle">{{TypeState?.Leaderboard_Setup?.LeaderboardTitle}}</span>
        </div>

        <div class="d-flex flex-grow-1">
            <div class="d-flex flex-column justify-content-around" style="flex:60">
                <div class="d-flex" *ngFor="let item of [].constructor(TypeState?.Leaderboard_Setup?.LeaderboardCount); let i = index"
                     [ngClass]="TypeState?.Leaderboard_Setup?.LeaderboardCount >= 8 ? 'font-size-24' : 'font-size-28'">
                    <div style="flex:13" cvLocalizedText langSection="Wallboard_Management_Messages" [langKey]="'Leader_Board_' + (i + 1) + '_Place'"></div>
                    <div class="text-truncate" style="flex:65" cvLocalizedText langSection="Common" langKey="Name">Name</div>
                    <div style="flex:22">00</div>
                </div>
            </div>

            <div class="d-flex flex-column justify-content-center" style="flex:40">
                <div class="rounded-circle" style="border:6px solid #FFFFFF">
                    <div class="rounded-circle" style="padding-top:100%; background:url(../Admin/ImageResizer.aspx?imgid=-2&w=500&h=500) center center / cover no-repeat"></div>
                </div>
            </div>
        </div>
    </div>

    <!--Challenges Preview-->
    <div class="w-100 color-white font-size-20 overflow-hidden p-2" [ngStyle]="{ 'background-color': FirstSlide.HasBackdrop ? 'rgba(0, 0, 0, 0.7' : '' }" *ngIf="FirstSlideType == 20">
        <div class="row pt-3 px-3 text-center">
            <div class="col-2 p-0" cvLocalizedText langSection="Common" langKey="Metric">Metric</div>
            <div class="col-2 p-0" cvLocalizedText langSection="Challenges" langKey="Leader">Leader</div>
            <div class="col-2 p-0" cvLocalizedText langSection="Challenges" langKey="Leading_Score">Leading Score</div>
            <div class="col-2 p-0" cvLocalizedText langSection="Challenges" langKey="Wager">Wager</div>
            <div class="col-2 p-0" cvLocalizedText langSection="Challenges" langKey="Pot">Pot</div>
            <div class="col-2 p-0" cvLocalizedText langSection="Common" langKey="End_Date">End Date</div>
        </div>

        <div class="row font-size-16 px-3" [class.mt-2]="!f" [class.pb-1]="l" *ngFor="let item of [].constructor(7); let f = first; let l = last">
            <div class="col d-flex align-items-center p-0 text-truncate">
                <img class="mx-2" style="width:36px; height:36px" src="../App_Themes/Standard/Images/CoreTheme/Dashboard/ModuleImages/Challenges/Challenge.png" />
                <span class="py-1" cvLocalizedText langSection="Metrics" langKey="Metric_Name_Placeholder">Metric Name</span>
            </div>

            <div class="text-center py-1 col-2 text-truncate" cvLocalizedText langSection="Common" langKey="Name">Name</div>
            <div class="text-right py-1 pr-5 col-2">00</div>

            <div class="text-center py-1 col-2">
                --<svg class="ml-1 fill-white" style="width:24px; height:24px" xmlns="http://www.w3.org/2000/svg"><use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use></svg>
            </div>

            <div class="text-center py-1 col-2">
                --<svg style="width:24px; height:24px" xmlns="http://www.w3.org/2000/svg" class="ml-1 fill-white"><use href="../App_Themes/clearview-default/icons/utility/coins.svg#coins"></use></svg>
            </div>

            <div class="text-center py-1 col-2">00/00/0000</div>
            <div class="mt-2 mt-1 mx-auto border-bottom" style="grid-row:3; width:98%; border-color:#D2D6DB !important" *ngIf="!l"></div>
        </div>
    </div>

    <!--Current Agent States Preview-->
    <div class="wallboardViewSlideContentArea wallboardViewSlideContentAreaLight color-white m-0 p-0 w-100 h-100" *ngIf="FirstSlideType == 17">
        <div style="box-sizing:border-box">
            <div class="wvCurrentAgentStatesTitle d-flex align-items-center w-100 font-size-16 text-center" style="height:100px; border-radius:12px"
                 [ngStyle]="{ 'background-color': FirstSlide.HasBackdrop ? 'rgba(0, 0, 0, 0.4)' : 'transparent' }">
                <div class="summaryTitle w-50 h-100 text-truncate text-left" style="flex:50">
                    <span class="d-inline-block mt-3" cvLocalizedText langSection="Common" langKey="Title">Title</span>
                </div>

                <div class="d-inline-block" style="width:20%; flex:20">
                    <div cvLocalizedText langSection="Wallboard_Management" langKey="Calls_In_Queue">Calls in Queue</div>
                    <div>00</div>
                </div>

                <div class="d-inline-block" style="width:30%; flex:30">
                    <div cvLocalizedText langSection="Wallboard_Management" langKey="Longest_Call_In_Queue">Longest Call in Queue</div>
                    <div>00:00:00</div>
                </div>

                <div class="d-inline-block" style="width:20%; flex:20">
                    <div cvLocalizedText langSection="Module" langKey="Total_Agents">Total Agents</div>
                    <div>00</div>
                </div>
            </div>
        </div>

        <div class="clearBoth"></div>

        <div class="wvCurrentAgentStatesTableData font-size-16" style="height:280px">
            <div class="wvCurrentAgentStatesColumn" style="flex:2; max-width:40%; display:grid; grid-template-columns:30px auto auto 100px"
                 [ngStyle]="{ 'background-color': FirstSlide.HasBackdrop ? 'rgba(0, 0, 0, 0.4)' : 'transparent' }">
                <div class="wvCurrentAgentStatesColumnTitle d-flex" style="max-height:180px; grid-row-start:1; grid-column:span 4">
                    <div>
                        <span cvLocalizedText langSection="Wallboard_Management" langKey="Inbound">Inbound</span>
                        <span class="wvCurrentAgentStatesStateBox d-inline-block mb-3" style="padding:0px 10px; background-color:#7C52BF">0</span>
                    </div>

                    <div>
                        <span cvLocalizedText langSection="Wallboard_Management" langKey="Outbound">Outbound</span>
                        <span class="wvCurrentAgentStatesStateBox d-inline-block mb-3" style="padding:0px 10px; background-color:#E4B321">0</span>
                    </div>
                </div>

                <div class="wvCurrentAgentStatesStateIndicator mt-2" [ngStyle]="{ 'background-color': i % 2 == 0 ? '#7C52BF' : '#E4B321', 'grid-row-start': i + 2 }"
                     *ngFor="let item of [].constructor(4); let i = index"></div>
                <div class="wvCurrentAgentStatesGridCell wvCASEllip" [ngStyle]="{ 'grid-row-start': i + 2 }" *ngFor="let item of [].constructor(4); let i = index"
                     cvLocalizedText langSection="Common" langKey="Name">Name</div>
                <div class="wvCurrentAgentStatesGridCell wvCASEllip" [ngStyle]="{ 'grid-row-start': i + 2 }" *ngFor="let item of [].constructor(4); let i = index"
                     cvLocalizedText langSection="Module" langKey="State_Header">State</div>
                <div class="wvCurrentAgentStatesGridCell wvTimeCell" [ngStyle]="{ 'grid-row-start': i + 2 }" *ngFor="let item of [].constructor(4); let i = index"
                     cvLocalizedText langSection="Interval_Module" langKey="Time">Time</div>
            </div>

            <div class="wvCurrentAgentStatesColumn" style="flex:1.5; max-width:35%; display:grid; grid-template-columns:auto auto 100px"
                 [ngStyle]="{'background-color': FirstSlide.HasBackdrop ? 'rgba(0, 0, 0, 0.4)' : 'transparent'}">
                <div class="wvCurrentAgentStatesColumnTitle" style="min-height:45px; max-height:90px; grid-row-start:1; grid-column:span 3">
                    <span cvLocalizedText langSection="Wallboard_Management" langKey="Unavailable">Unavailable</span>
                    <span class="wvCurrentAgentStatesStateBox d-inline-block mb-3" style="padding:0px 10px; background-color:#BD2026">0</span>
                </div>

                <div class="wvCurrentAgentStatesGridCell wvCASEllip" [ngStyle]="{ 'grid-row-start': i + 2 }" *ngFor="let item of [].constructor(4); let i = index"
                     cvLocalizedText langSection="Common" langKey="Name">Name</div>
                <div class="wvCurrentAgentStatesGridCell wvCASEllip p-2" style="border-radius:12px" [ngStyle]="{ 'background-color': i < 2 ? '#F24813' : '#BD2026', 'grid-row-start': i + 2 }"
                     *ngFor="let item of [].constructor(4); let i = index" cvLocalizedText langSection="Module" langKey="State_Header">State</div>
                <div class="wvCurrentAgentStatesGridCell wvTimeCell" [ngStyle]="{ 'grid-row-start': i + 2 }" *ngFor="let item of [].constructor(4); let i = index"
                     cvLocalizedText langSection="Interval_Module" langKey="Time">Time</div>
            </div>

            <div class="wvCurrentAgentStatesColumn" style="flex:1; max-width:25%; display:grid; grid-template-columns:auto 70px"
                 [ngStyle]="{ 'background-color': FirstSlide.HasBackdrop ? 'rgba(0, 0, 0, 0.4)' : 'transparent' }">
                <div class="wvCurrentAgentStatesColumnTitle" style="min-height:45px; max-height:90px; grid-row-start:1; grid-column:span 3">
                    <span cvLocalizedText langSection="Wallboard_Management" langKey="Available">Available</span>
                    <span class="wvCurrentAgentStatesStateBox d-inline-block mb-3" style="padding:0px 10px; background-color:#3D9649">0</span>
                </div>

                <div class="wvCurrentAgentStatesGridCell wvCASEllip" [ngStyle]="{ 'grid-row-start': i + 2 }" *ngFor="let item of [].constructor(4); let i = index"
                     cvLocalizedText langSection="Common" langKey="Name">Name</div>
                <div class="wvCurrentAgentStatesGridCell wvTimeCell" [ngStyle]="{ 'grid-row-start': i + 2 }" *ngFor="let item of [].constructor(4); let i = index"
                     cvLocalizedText langSection="Interval_Module" langKey="Time">Time</div>
            </div>
        </div>
    </div>

    <!--Summary Preview-->
    <div class="d-flex flex-column w-100 font-size-16 color-white p-3" style="text-shadow:2px 2px 8px #000000" *ngIf="FirstSlideType == 4">
        <div class="d-flex justify-content-between align-items-center py-2 px-4" style="border-radius:8px" [ngStyle]="{ 'background': FirstSlide.HasBackdrop ? 'rgba(0,0,0,0.7)' : '' }">
            <div class="font-size-32 text-truncate" *ngIf="TypeState?.Summary_Settings?.SummaryTitle">{{TypeState?.Summary_Settings?.SummaryTitle}}</div>
            <div class="font-size-32 invisible" *ngIf="!TypeState?.Summary_Settings?.SummaryTitle">Placeholder</div>
            <div *ngIf="FirstSlide.HasPagination">1/10</div>
        </div>

        <div class="py-2 px-4 mt-3 overflow-hidden" style="border-radius:8px; max-height:calc(100% - 136px)"
             [ngStyle]="{ 'background': FirstSlide.HasBackdrop ? 'rgba(0,0,0,0.7)' : '', 'max-height': 'calc(100% - ' + (68 + (FirstSlide.HasTotalsRow ? 68 : 0)) + 'px)' }">
            <div class="d-flex pb-2 mb-2" style="border-bottom:1px solid #FFFFFF; box-shadow:0px 12px 8px -9px #000000">
                <div class="col-2 p-0 text-truncate" cvLocalizedText langSection="Wallboard_Management" langKey="Name">Name</div>
                <div class="flex-grow-1"></div>
                <div class="col-1 px-1 text-center text-truncate" *ngFor="let metric of selectedMetricInfo | slice:0:10">{{metric.DisplayName}}</div>
            </div>

            <div class="d-flex pb-1 border-bottom" *ngFor="let item of [].constructor(20); let i = index">
                <div class="col-2 p-0 text-truncate">
                    <span class="pr-2" *ngIf="TypeState?.Summary_Settings?.ShowRank">{{i + 1}}</span>
                    <span cvLocalizedText langSection="Wallboard_Management" langKey="Agent">Agent</span>
                </div>

                <div class="flex-grow-1"></div>
                <div class="col-1 text-center" *ngFor="let metric of selectedMetricInfo | slice:0:10">00</div>
            </div>
        </div>

        <div class="d-flex py-2 px-4 mt-3" style="border-radius:8px" [ngStyle]="{ 'background': FirstSlide.HasBackdrop ? 'rgba(0,0,0,0.7)' : '' }" *ngIf="FirstSlide.HasTotalsRow">
            <div class="col-2 p-0 text-truncate" cvLocalizedText langSection="Wallboard_Management" langKey="Totals">Totals</div>
            <div class="flex-grow-1"></div>
            <div class="col-1 text-center" *ngFor="let metric of selectedMetricInfo | slice:0:10">00</div>
        </div>
    </div>

    <!--Random Racing-->
    <div class="d-flex justify-content-center w-100 color-cerulean lato-bold text-truncate" style="font-size:5vw; padding-top:37%; cursor:default"
         *ngIf="FirstSlideType == 2 && TypeState?.Racing_Setup?.Theme == 'Random'" cvLocalizedText langSection="Wallboard_Management" langKey="Random_Racing">Random</div>

    <!--Play Button-->
    <svg class="fill-casper cursor-pointer position-absolute" style="height:111px; width:111px; top:50%; left:50%; transform:translate(-50%,-50%); z-index:1; filter:drop-shadow(1px 2px 3px #353a40)"
         (click)="launchWallboardService.openWallboardPreview(FirstSlide.WallboardID)">
        <use href="../App_Themes/clearview-default/icons/utility/play.svg#play"></use>
    </svg>
</div>
